<template>
    <a
      class="nav-link"
      :class="{ 'active show': customizer == 'layouts' }"
      id="c-pills-home-tab" data-bs-toggle="pill" role="tab" aria-controls="c-pills-layouts" :aria-selected="customizer == 'layouts' ? 'true' : 'false' " data-original-title title
      @click="openCustomizerSetting('layouts')"
      href="javascript:void(0)"
    >
      <div class="settings">
        <i class="icon-paint-bucket customizer-icon-color"></i>
      </div>
      
    </a>
  </template> 

  <script>
    import { mapState } from 'vuex';

    export default {
      name: 'customizerLayout',
      computed: {
        ...mapState({
          customizer: (state) => state.menu.customizer
        }),
      },
      methods : {
        openCustomizerSetting(val) {
          this.$store.state.menu.customizer = val;
        },
      }
    };
  </script>
